<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import DonutChart from "@shared/svelte/Components/DonutChart.svelte";
  import moneyFormatters from "@shared/filters/money.js";

  export let reportsOverview: {
    num_distributors: number;
    num_order_groups: number;
    num_orders: number;
    num_products: number;
    total_spend: number;
  };
  export let reportsOverviewCategories: {
    type1_percentage: number;
    type1_total_spend: number;
    type2_percentage: number;
    type2_total_spend: number;
    type3_percentage: number;
    type3_total_spend: number;
    type4_percentage: number;
    type4_total_spend: number;
  };
  export let linkHref = null;

  const getLabelValue = function (value: number) {
    return value ? value.toFixed(0) : 0;
  };

  let chartLabels = [];
  let chartData = {};

  $: if (reportsOverviewCategories) {
    chartLabels = [
      "Beer: $" + getLabelValue(reportsOverviewCategories.type1_total_spend),
      "Wine: $" + getLabelValue(reportsOverviewCategories.type2_total_spend),
      "Liquor: $" + getLabelValue(reportsOverviewCategories.type3_total_spend),
      "Other: $" + getLabelValue(reportsOverviewCategories.type4_total_spend),
    ];
    chartData = {
      labels: chartLabels,
      datasets: [
        {
          data: [
            reportsOverviewCategories.type1_percentage,
            reportsOverviewCategories.type2_percentage,
            reportsOverviewCategories.type3_percentage,
            reportsOverviewCategories.type4_percentage,
          ],
          backgroundColor: ["#002B48", "#406076", "#99AAB6", "#E5E9EC"],
        },
      ],
    };
  }

</script>

<style>
  @media only screen and (max-width: 700px) {
    .fizz-card {
      width: 100%;
    }
  }

  .border-bottom-row {
    border-bottom: 1px solid #eaeaea;
  }

  .icon-padding {
    padding-top: 0.2rem;
  }

</style>

{#if reportsOverview}
  <div
    class="fizz-card fizz-flex-item fizz-card-interactive fizz-flex-no-shrink fizz-inset-squish-16"
  >
    <!-- svelte-ignore a11y-missing-content -->
    <a href={linkHref} class="fizz-overlay-link" />
    <div class="fizz-flex-row border-bottom-row">
      <dl
        class="fizz-definition-list fizz-flex-row-0 fizz-flex-wrap fizz-inset-square-24 fizz-full-width fizz-border-bottom"
        style="--gap: 32px"
      >
        <div class="fizz-flex-item">
          <dt>Orders</dt>
          <dd class="reports-overview-num-orders">{reportsOverview.num_orders}</dd>
        </div>
        <div class="fizz-flex-item">
          <dt class="fizz-text-subdued">PRODUCTS</dt>
          <dd class="reports-overview-num-products">{reportsOverview.num_products}</dd>
        </div>
        <div class="fizz-flex-item">
          <dt class="fizz-text-subdued">DISTRIBUTORS</dt>
          <dd class="reports-overview-num-distributors">{reportsOverview.num_distributors}</dd>
        </div>
        <div class="fizz-text-positive fizz-flex-item">
          <dt class="fizz-text-subdued">*SPEND</dt>
          <dd class="reports-overview-spend fizz-text-positive">
            {moneyFormatters.filter5()(reportsOverview.total_spend)}
          </dd>
        </div>
      </dl>
      <div class="fizz-flex-item fizz-align-self-start icon-padding">
        <div class="fizz-flex-row fizz-justify-end">
          <Icon type="ArrowRight" />
        </div>
      </div>
    </div>

    <DonutChart {chartLabels} {chartData} extraClasses={"reports-overview-categories"} />
  </div>
{/if}
